<template>
       <div class="AfterSalesManage">
        <div class="AfterSalesManage-menu">
            <div class="AfterSalesManage-menu-breadcrumb">
                <Breadcrumb></Breadcrumb>
            </div>
            <div class="AfterSalesManage-menu-btn">
                <!-- <el-button type="primary">新增分类</el-button> -->
            </div>
        </div>
        <div class="AfterSalesManage-content">
            <div class="AfterSalesManage-content-card">
                <div class="AfterSalesManage-content-card-title">
                    <div style="flex: 1;display: flex;align-items: center;" @click="showMenu = !showMenu">
                        <i class="el-icon-caret-right iconsan"
                            :style="{ transform: showMenu ? 'rotate(90deg)' : 'rotate(0deg)' }"
                            style="font-size: 16px;margin-right: 3px;"></i>
                        我的分类
                    </div>
                    <i class="el-icon-circle-plus-outline icons" @click="_add" style="font-size: 20px;"></i>
                </div>
                <el-collapse-transition>
                    <div class="AfterSalesManage-content-card-list" v-show="showMenu">
                        <div class="AfterSalesManage-content-card-list-item"
                            @click.stop="getAfterSalesListDetail(item.id)"
                            :class="{ 'activeStyle': activeName === item.id }" v-for="item in menu" :key="item.id">
                            <div class="AfterSalesManage-content-card-list-item-left">
                                <!-- <i class="el-icon-star-off" style="font-size:16px;margin-right: 8px;"></i> -->
                                <div>{{ item.t_name }}</div>
                            </div>
                            <div class="AfterSalesManage-content-card-list-item-right">
                                <i class="el-icon-edit icons" style="font-size: 14px;" @click.stop="edit(item)"></i>
                                <i class="el-icon-delete icons" style="font-size: 14px;margin-left: 10px;"
                                    @click.stop="del(item)"></i>
                            </div>
                        </div>
                    </div>
                </el-collapse-transition>
            </div>
            <div class="AfterSalesManage-content-table">
                <div class="AfterSalesManage-content-table-search">
                    <div class="AfterSalesManage-content-table-search-left">
                        <el-input v-model="initParams.T_name" size="small" placeholder="请输入标题"></el-input>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="_search">搜索</el-button>
                    </div>
                    <el-button type="primary" size="small" @click="_addinnerDialog"
                        icon="el-icon-circle-plus-outline">添加</el-button>
                </div>

                <el-table v-loading="loading" border :data="tableData" style="margin-top:20px;width: 100%;" size="mini">
                    <el-table-column prop="t_name" label="标题" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="t_content" label="内容" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="t_category_name" label="分类名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="t_name" label="附件" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div @click="_showAttachDialog(scope.row.t_attachments || [])"
                                style="text-decoration: underline; cursor: pointer;color: #409eff;">
                                查看附件
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="t_display" label="显示" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.t_display === 1 ? 'success' : 'danger'">{{ scope.row.t_display ===
                                1 ? '显示' : '隐藏' }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="editinner(scope.row)">编辑</el-button>
                            <el-button type="danger" size="mini" @click="delinner(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    style="margin-top: 20px;" :current-page="initParams.page" :page-size="initParams.page_z"
                    layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

        <!-- // 【分类】新增、编辑分类 -->
        <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :append-to-body="true">
            <el-form ref="FormRef" :model="form" :rules="rules" label-width="100px" label-position="top">
                <el-form-item label="分类名称" prop="T_name">
                    <el-input v-model="form.T_name"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="T_sort">
                    <el-input v-model="form.T_sort"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit('FormRef')">确 定</el-button>
            </span>
        </el-dialog>

        <!-- // 【分类子项】新增、编辑分类 -->
        <el-dialog :title="innertitle" :visible.sync="innerDialogVisible" width="500px" :append-to-body="true"
            :destroy-on-close="true">
            <div style="height: 50vh;overflow: auto;">
                <el-form ref="innerFormRef" :model="innerForm" :rules="innerRules" label-width="60px">
                    <el-form-item label="分类" prop="T_category">
                        <el-select v-model="innerForm.T_category" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in menu" :key="item.id" :label="item.t_name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标题" prop="T_name">
                        <el-input v-model="innerForm.T_name"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" prop="T_content">
                        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="innerForm.T_content">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="显示" prop="T_display">
                        <el-radio-group v-model="innerForm.T_display">
                            <el-radio :label="1">显示</el-radio>
                            <el-radio :label="2">隐藏</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="附件" prop="T_attachments">
                        <el-upload class="upload-demo" :http-request="handleHttpRequest" :on-remove="handleRemove"
                            :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :limit="9"
                            :on-exceed="handleExceed" :file-list="innerForm.T_attachments"
                            action="https://qiniu.region.z2"
                            accept=".jpg,.jpeg,.png,.gif,.bmp,.svg,.mp4,.avi,.mov,.wmv,.flv,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt">
                            <el-button size="small" icon="el-icon-upload" plain type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">支持文档、图片、视频等文件，文件大小不超过30M</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="innerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click='onSubmitFun'>确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog title="查看附件" :visible.sync="showAttachDialog" width="500px" :append-to-body="true">
            <div style="display: flex;flex-direction: column;gap:20px;max-height: 50vh;overflow: auto;">
                <div v-for="(item, index) in innerAttData" :key="index"
                    style="display: flex;justify-content: space-between;">
                    <div>
                        <i class="el-icon-link"></i>
                        <span> {{ item.name }}</span>
                    </div>
                    <el-button @click="_innerAttachDialog(item)" size="mini" type="primary">查看</el-button>
                </div>
            </div>

            <el-dialog title="阅览" width="90%" :visible.sync="innerAttachDialog" :append-to-body="true" top="1vh">
                <iframe :src="FileUrl" frameborder="0" width="100%" style="height: calc(87vh - 60px);"></iframe>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
import { PDFToken } from "@/api/pdfToken.js";
import * as qiniu from "qiniu-js";
import {
    allAfterSalesCategory,//获取售后分类列表
    addAfterSalesCategory,//添加售后分类
    editAfterSalesCategory,//编辑售后分类
    deleteAfterSalesCategory,//删除售后分类

    getAfterSalesList,//获取售后分类详情
    addAfterSales,//添加售后分类子项
    editAfterSales,//编辑售后分类子项
    deleteAfterSales,//删除售后分类子项
} from "@/api/AfterSalesManage.js";
export default {
    name: "",
    data() {
        return {
            showAttachDialog: false,//查看附件弹窗
            innerAttachDialog: false,
            innerAttData: [],
            FileUrl: '',//查看附件弹窗数据

            total: 0,
            loading: false,
            dialogVisible: false,
            title: '新增分类',
            form: {
                T_name: '',//分类名称
                T_sort: '',//排序
            },
            rules: {
                T_name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
                T_sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
            },
            innerRules: {
                T_category: [{ required: true, message: '请选择分类', trigger: 'blur' }],
                T_name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                T_content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
                T_display: [{ required: true, message: '请选择显示', trigger: 'blur' }],
                T_attachments: [{ required: true, message: '请上传附件', trigger: ['blur', 'change'] }],//附件
            },
            innerForm: {
                T_category: '',//分类
                T_name: '',//标题
                T_content: '',//内容
                T_display: 1,//1显示，2隐藏
                T_attachments: [],//附件
            },
            initParams: {//获取售后分类详情
                page: 1,
                page_z: 10,
                T_category: '',//分类id
                T_name: '',//标题
            },
            innerDialogVisible: false,
            innertitle: '新增',//新增分类子项
            showMenu: true,
            menu: [],//分类列表
            activeName: '1',
            tableData: [],
        }
    },
    mounted() {
        //获取售后分类列表
        this.allAfterSalesCategoryList();
    },
    methods: {
        _innerAttachDialog(item) {
            this.innerAttachDialog = true;
            let str = item.url.split('.').pop();
            console.log(str);
            if (['pdf', 'xlsx', 'xls', 'docx', 'doc'].includes(str)) {
                this.FileUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${item.url}`;
            } else {
                this.FileUrl = item.url;
            }
        },
        fileType(url) {
            console.log(url);
            let str = url.split('.').pop();
            if (['pdf', 'xlsx', 'xls', 'docx', 'doc'].includes(str)) {
                return {
                    src: require(`@/assets/img/${str}.png`),
                    type: false
                };
            } else {
                return {
                    src: url,
                    type: true
                }
            }
        },
        _showAttachDialog(row) {
            this.showAttachDialog = true;
            console.log(row);
            this.innerAttData = [...row, { name: '查看.xlsx', url: 'https://bzdcoldverifyoss.baozhida.cn/UpImage/17580045879e3bea5b-8735-462a-a285-b84580202a98.xlsx' }]
        },
        //每页显示多少
        handleSizeChange(val) {
            this.initParams.page_z = val;
            this.getAfterSalesListDetail(this.activeName, true);
        },
        //多少页
        handleCurrentChange(val) {
            this.initParams.page = val;
            this.getAfterSalesListDetail(this.activeName, true);
        },
        //搜索
        _search() {
            this.initParams.page = 1;
            this.getAfterSalesListDetail(this.activeName, true);
        },
        //提交分类
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let apiMethod = this.title === '新增分类' ? addAfterSalesCategory : editAfterSalesCategory;
                    apiMethod(this.form).then(({ data: res }) => {
                        if (res.Code == 200) {
                            this.$message.success(res.Msg);
                            this.dialogVisible = false;
                            this.allAfterSalesCategoryList();
                        }
                    })
                } else {
                    return false;
                }
            })
        },
        //获取售后分类列表
        allAfterSalesCategoryList() {
            allAfterSalesCategory({ page: 1, page_z: 999 }).then(({ data: res }) => {
                if (res.Code == 200) {
                    this.menu = res.Data || [];
                    this.initParams.page = 1;
                    this.getAfterSalesListDetail(this.menu[0].id);
                }
            })
        },
        //获取售后分类-->详情
        getAfterSalesListDetail(item, refresh = false) { //refresh为true可以刷新
            this.loading = true;
            if (item == this.activeName && !refresh) {
                return;
            }
            this.activeName = item;
            this.initParams.T_category = item;
            getAfterSalesList(this.initParams).then(({ data: res }) => {
                if (res.Code == 200) {
                    this.tableData = res.Data.Data || [];
                    this.total = res.Data.Num || 0;
                }
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            })
        },
        //提交
        onSubmitFun() {
            this.$refs.innerFormRef.validate((valid) => {
                if (valid) {
                    let formData = { ...this.innerForm };
                    formData.T_attachments = JSON.stringify(this.innerForm.T_attachments);
                    let apiMethod = this.innertitle === '新增' ? addAfterSales : editAfterSales;
                    apiMethod(formData).then(({ data: res }) => {
                        if (res.Code == 200) {
                            this.$message.success(res.Msg);
                            this.innerDialogVisible = false;
                            this.initParams.page = 1;
                            this.getAfterSalesListDetail(this.activeName, true);
                        }
                    })
                } else {
                    return false;
                }
            })
        },
        // 【分类】新增分类
        _add() {
            this.title = '新增分类';
            this.dialogVisible = true;
            this.form = {
                T_name: '',//分类名称
                T_sort: '',//排序
            }
        },
        // 【分类】编辑分类
        edit(item) {
            this.title = '编辑分类';
            this.dialogVisible = true;
            this.form = {
                T_id: item.id,//分类id
                T_name: item.t_name,//分类名称
                T_sort: item.t_sort,//排序
            }
        },
        // 【分类】删除分类
        del(item) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteAfterSalesCategory({ T_id: item.id }).then(({ data: res }) => {
                    if (res.Code == 200) {
                        this.$message.success(res.Msg);
                        this.allAfterSalesCategoryList();
                    }
                })
            })

        },
        // 【分类子项】新增分类子项
        _addinnerDialog() {
            if (this.$refs.innerFormRef) {
                this.$refs.innerFormRef.resetFields();
            }
            this.innertitle = '新增';
            this.innerForm = {
                T_name: '',//标题
                T_category: '',//分类
                T_content: '',//内容
                T_display: 1,//1显示，2隐藏
                T_attachments: [],//附件
            }
            this.innerDialogVisible = true;
        },
        // 【分类子项】编辑分类子项
        editinner(item) {
            if (this.$refs.innerFormRef) {
                this.$refs.innerFormRef.resetFields();
            }
            this.innertitle = '编辑';
            this.innerDialogVisible = true;
            let { id, t_category, t_name, t_content, t_display, t_attachments } = item;
            this.innerForm = {
                T_id: id,//分类子项id
                T_category: t_category,//分类
                T_name: t_name,//标题
                T_content: t_content,//内容
                T_display: t_display,//1显示，2隐藏
                T_attachments: t_attachments || [],//附件
            }
            console.log('编辑', this.innerForm);
        },
        // 【分类子项】删除分类子项
        delinner(item) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除操作
                deleteAfterSales({ T_id: item.id }).then(({ data: res }) => {
                    if (res.Code == 200) {
                        this.$message.success(res.Msg);
                        this.initParams.page = 1;
                        this.getAfterSalesListDetail(this.activeName, true);
                    }
                })
            }).catch(() => {
                // 取消操作
            });
        },



        //*********************************************************上传附件的操作 */
        beforeUpload(file) {
            const isLt30M = file.size / 1024 / 1024 < 100;
            if (!isLt30M) {
                this.$message.error('文件大小不能超过100MB!');
                return false;
            }
            return true;
        },
        handleRemove(file) {
            this.innerForm.T_attachments = this.innerForm.T_attachments.filter(item => item.name !== file.name);
        },
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择9个文件，本次选择了 ${files.length
                } 个文件，共选择了 ${files.length + fileList.length} 个文件`
            );
        },
        beforeRemove(file) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },

        handleHttpRequest(options) {
            let self = this;
            // 1. 先从后端接口获取七牛云上传token
            var fileName = options.file.name.substring(
                options.file.name.lastIndexOf(".") + 1
            ); //获取后缀 png jpg
            PDFToken({
                T_suffix: fileName
            }).then(({ data: res }) => {
                if (res.Code == 200) {
                    // 2. 构造七牛云上传表单数据
                    self.uploadToQiniu(options.file, res.Data);
                } else {
                    console.log("获取token失败");
                }
            });
        },

        // 获取七牛云上传token的方法

        uploadToQiniu(file, token) {
            const loading = this.$loading({
                lock: true,
                text: "正在上传文件，请稍后...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            var _this = this;
            var key = file.name || null;
            var config = {
                useCdnDomain: true, //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
                region: qiniu.region.z2,
                domain: "https://qiniu.region.z2", //配置好的七牛云域名  如   https://cdn.qniyun.com/
                // chunkSize: 1000, // 修改为4MB的分片大小（标准配置）
                forceDirect: false //直传还是断点续传方式，true为直传
            };
            var putExtra = {
                fname: file.name, //文件原始文件名
                params: {},
                mimeType: [] || null // 自动检测MIME类型
            };
            var observable = qiniu.upload(file, key, token, putExtra, config);
            //   设置实例的监听对象
            var observer = {
                next(res) {
                    //上传进度
                    // console.log("实例监听对象", res);
                },
                // 接收上传错误信息
                error(err) {
                    loading.close();
                    console.log("上传错误", err);
                    switch (err.code) {
                        case 413:
                            _this.$message.error("错了哦，图片可能太大了哦");
                            break;
                        case 408:
                            _this.$message.error("错了哦，请求超时");
                            break;
                        default:
                            _this.$message.error("错了哦，上传错误");
                    }
                },
                // 接收上传完成后的信息
                complete(com) {
                    loading.close();
                    _this.innerForm.T_attachments.push({
                        name: file.name,
                        url: com.key
                    });
                }
            };
            observable.subscribe(observer);
        }

    }
}
</script>
<style lang="scss">
.icons:hover {
    color: #409eff;
}

.iconsan {
    transition: transform 0.1s ease-in-out;
}

.AfterSalesManage {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;

    &-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(#fff, 1);
        height: 70px;
        padding: 15px 10px;
        box-shadow: 5px 5px 10px -10px #000;

        &-breadcrumb {
            padding-left: 20px;
        }

        &-btn {
            padding-right: 20px;
        }
    }

    &-content {
        background: rgba(#fff, 1);
        margin: 30px 10px;
        color: #000;
        flex: 1;
        display: flex;

        &-card {
            min-width: 220px;
            border-right: 1px solid #f1f2f4;
            user-select: none;
            padding: 10px;

            &-title {
                font-size: 14px;
                font-weight: bold;
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;
                border-radius: 10px;
                padding: 10px;
                color: #636d7e;
            }

            &-list {
                padding-left: 10px;
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                gap: 5px;

                &-item {
                    cursor: pointer;
                    font-size: 12px;
                    border-radius: 10px;
                    padding: 10px;

                    &:hover {
                        background: #fafafc;
                    }

                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: #636d7e;

                    &-left {
                        display: flex;
                        flex: 1;
                        height: 100%;
                        padding-left: 10px;
                    }

                    &-right {
                        display: none;
                        height: 100%;
                    }

                    &:hover &-right {
                        display: block;
                    }
                }
            }

        }



        &-table {
            padding: 10px;
            flex: 1;

            &-search {
                display: flex;
                align-items: center;
                justify-content: space-between;

                &-left {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
            }
        }
    }
}

.activeStyle {
    background: #eef9fe;
    color: #409eff;
}
</style>